
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { DeviceInfo, SharedDeviceInfo } from '@/types/device-info';
import { Mutation } from 'vuex-class';
import { mutations } from '@/store/types';
import { SetDeviceMutationType, SetDevicesMutationType } from '@/types/store/mutations';
import * as dlg from '@/modules/dlg';
import { Action, State } from 'vuex-class';
import { LoadDevicesActionType, LoadDeviceActionType } from '@/types/store/actions';
import { actions } from '../../../store/types';
import { UserInfo } from '../../../types/user-info';
import { validatePrivilege } from '@/utils/devices';
import { DevicePrivileges } from '@/constants/device_privileges';
import api from '@/modules/api';
import { getErrorMessage } from '@/utils/common';
import LoadableMixin from '@/mixins/LoadableMixin';

@Component({
    mixins: [LoadableMixin],
})
export default class GroupOptionsMenu extends Mixins<LoadableMixin>(LoadableMixin) {
    protected shares: SharedDeviceInfo[] = [];
    protected share: SharedDeviceInfo | null = null;
    protected ManageSharingTitle = 'Manage sharing';
    protected showFullForm = false;
    protected tableLoading = false;
    protected validatePrivilege = validatePrivilege;
    protected DevicePrivileges = DevicePrivileges;

    @Action(actions.LOAD_DEVICES)
    loadDevices!: LoadDevicesActionType;

    @Action(actions.LOAD_DEVICE)
    loadDevice!: LoadDeviceActionType;

    @Mutation(mutations.SET_CURRENT_DEVICE)
    setCurrentDevice!: SetDeviceMutationType;

    @Mutation(mutations.SET_DEVICES)
    setDevices!: SetDevicesMutationType;

    @State('user')
    user!: UserInfo;

    @Prop({
        default() {
            return [];
        },
    })
    hideOptions!: string[];

    @Prop({ required: false })
    optionClasses!: string;

    @Prop({ required: true })
    group!: any;

    @State('device')
    current!: DeviceInfo;

    @State('devices')
    devices!: DeviceInfo[];

    validateRestricted() {
        return true;
    }

    has(opt: string) {
        return !this.hideOptions.includes(opt);
    }
    async onDeleteDeviceGroup() {
        const confirmed = await dlg.confirm("Are you sure you want to delete this group?", 'Delete');
        if (!confirmed) return;
        try {
            const groupId = this.group._id;
            this.$store.commit(mutations.SET_SELECTED_DEVICE_TYPE, { selectedDeviceType: 'all' });
            this.$store.commit(mutations.LOADING, { loading: true });
            this.$store.commit(mutations.SET_SEARCH_NAME, { searchName: '' });
            const filteredDevices = await api.loadDevices(
                this.user._id as string,
                { page: 0, perPage: 999 },
                'all',
                '',
            );
            this.$store.commit(mutations.SET_DEVICES, { devices: filteredDevices });

            this.load(
                async () => {
                    await api.deleteDeviceGroup(groupId)
                    this.$router.push({ name: 'device-overview', params: { deviceUUID: this.current.deviceUUID as string } });
                },
            );
        } catch (error) {
            Vue.toasted.error(getErrorMessage(error));
        } finally {
            this.$store.commit(mutations.LOADING, { loading: false });
        }
    }

    onEditGroup() {
        this.$router.push({ name: 'edit-group-device', params: { groupId: this.group._id } });
    }
}
